export class DownTimePieChartDto{
reason:string
percent:number
constructor(reason:string,
    percent:number){
        this.reason=reason;
        this.percent=percent;
    }
}
